import { TierItem } from "../pages/components/tierList";

export const nationalParksList: TierItem[] = [
    { name: "Acadia National Park", tier: "S" },
    { name: "Arches National Park", tier: "A" },
    { name: "Badlands National Park", tier: "B" },
    { name: "Big Bend National Park", tier: "B" },
    { name: "Biscayne National Park", tier: "B" },
    { name: "Black Canyon of the Gunnison National Park", tier: "B" },
    { name: "Bryce Canyon National Park", tier: "A" },
    { name: "Canyonlands National Park", tier: "C" },
    { name: "Capitol Reef National Park", tier: "S" },
    { name: "Carlsbad Caverns National Park", tier: "S" },
    { name: "Channel Islands National Park", tier: "B" },
    { name: "Congaree National Park", tier: "NA" },
    { name: "Crater Lake National Park", tier: "A" },
    { name: "Cuyahoga Valley National Park", tier: "C" },
    { name: "Death Valley National Park", tier: "S" },
    { name: "Denali National Park", tier: "NA" },
    { name: "Dry Tortugas National Park", tier: "S" },
    { name: "Everglades National Park", tier: "C" },
    { name: "Gates of the Arctic National Park", tier: "NA" },
    { name: "Gateway Arch National Park", tier: "F" },
    { name: "Glacier Bay National Park", tier: "NA" },
    { name: "Glacier National Park", tier: "S" },
    { name: "Grand Canyon National Park", tier: "S" },
    { name: "Grand Teton National Park", tier: "A" },
    { name: "Great Basin National Park", tier: "A" },
    { name: "Great Sand Dunes National Park", tier: "B" },
    { name: "Great Smoky Mountains National Park", tier: "A" },
    { name: "Guadalupe Mountains National Park", tier: "C" },
    { name: "Haleakalā National Park", tier: "NA" },
    { name: "Hawaiʻi Volcanoes National Park", tier: "NA" },
    { name: "Hot Springs National Park", tier: "C" },
    { name: "Indiana Dunes National Park", tier: "C" },
    { name: "Isle Royale National Park", tier: "NA" },
    { name: "Joshua Tree National Park", tier: "B" },
    { name: "Katmai National Park", tier: "NA" },
    { name: "Kenai Fjords National Park", tier: "NA" },
    { name: "Kings Canyon National Park", tier: "B" },
    { name: "Kobuk Valley National Park", tier: "NA" },
    { name: "Lake Clark National Park", tier: "NA" },
    { name: "Lassen Volcanic National Park", tier: "B" },
    { name: "Mammoth Cave National Park", tier: "C" },
    { name: "Mesa Verde National Park", tier: "C" },
    { name: "Mount Rainier National Park", tier: "A" },
    { name: "National Park of American Samoa", tier: "NA" },
    { name: "New River Gorge National Park and Preserve", tier: "B" },
    { name: "North Cascades National Park", tier: "A" },
    { name: "Olympic National Park", tier: "A" },
    { name: "Petrified Forest National Park", tier: "C" },
    { name: "Pinnacles National Park", tier: "B" },
    { name: "Redwood National Park", tier: "A" },
    { name: "Rocky Mountain National Park", tier: "A" },
    { name: "Saguaro National Park", tier: "B" },
    { name: "Sequoia National Park", tier: "A" },
    { name: "Shenandoah National Park", tier: "B" },
    { name: "Theodore Roosevelt National Park", tier: "B" },
    { name: "Virgin Islands National Park", tier: "B" },
    { name: "Voyageurs National Park", tier: "C" },
    { name: "White Sands National Park", tier: "C" },
    { name: "Wind Cave National Park", tier: "C" },
    { name: "Wrangell-St. Elias National Park", tier: "NA" },
    { name: "Yellowstone", tier: "A" },
    { name: "Yosemite National Park", tier: "S" },
    { name: "Zion National Park", tier: "A" },
];
